import style from './Botao.module.css'

export default function Botao({
    onClick,
    children,
    margin,
    disabled,
    background,
    marginBotton,
    marginSoft,
    triggerEnter
}) {
    const backgroundClass = background ? style[background] || style.background : null;

    const handleKeyDown = (event) => {
        if (triggerEnter && event.key === 'Enter') {
            onClick();
        }
    };
    return (
        <button
            onClick={onClick}
            className={[
                style.botao,
                margin && style.margin,
                disabled && style.disabled,
                backgroundClass,
                marginBotton && style.marginBotton,
                marginSoft && style.marginSoft
            ].filter(Boolean).join(' ')}
            disabled={disabled}
            onKeyDown={handleKeyDown}
        >
            {children}
        </button>
    )
}
